// extracted by mini-css-extract-plugin
export default {"organizationsTable":"organizations-table-container__organizations-table___8nKF"};